
   <div id="page-container" class="main-content-boxed">
      <!-- Main Container -->
      <main id="main-container">
          <!-- Page Content -->
          <div class="bg-gd-duskx">
              <div class="hero-static content content-full bg-white invisibles" data-toggle="appears">
                  <!-- Header -->
                  <div class="py-30 px-5 text-center">

                      <h1 class="h2 font-w700 mt-50 mb-10">Create New Account</h1>
                  </div>
                  <!-- END Header -->

                  <div id="divLoginWait"  *ngIf="loginStatus === 1">One moment please...</div>
                  <div *ngIf="loginStatus === 0">
                  <!-- Sign Up Form -->


                  <div style='color: brown; padding: 5px; font-weight: bold' *ngIf="loginError != ''">
                    {{error}} 
                </div>

                  <div class="row justify-content-center px-5">
                      <div class="col-sm-8 col-md-6 col-xl-4">
                          <!-- jQuery Validation (.js-validation-signup class is initialized in js/pages/op_auth_signup.js) -->
                          <!-- For more examples you can check out https://github.com/jzaefferer/jquery-validation -->
                          <form class="js-validation-signup"  >

                              <div class="form-group row">
                                  <div class="col-12">
                                      <div class="form-material">
                                          <input type="email" class="form-control" id="signup-email" name="signup-email" [(ngModel)]="model.Email" >
                                          <label for="signup-email">Email</label>
                                      </div>
                                  </div>
                              </div>
                              <div class="form-group row">
                                  <div class="col-12">
                                      <div class="form-material">
                                          <input type="password" class="form-control" id="signup-password" name="signup-password" [(ngModel)]="model.Password" >
                                          <label for="signup-password">Password</label>
                                      </div>
                                  </div>
                              </div>
                              <div class="form-group row">
                                  <div class="col-12">
                                      <div class="form-material">
                                          <input type="password" class="form-control" id="signup-password-confirm" name="signup-password-confirm" [(ngModel)]="model.ConfirmPassword" >
                                          <label for="signup-password-confirm">Password Confirmation</label>
                                      </div>
                                  </div>
                              </div>
                              <div class="form-group row text-center">
                                  <div class="col-12">
                                      <label class="css-control css-control-primary css-checkbox">
                                          <input type="checkbox" class="css-control-input" id="signup-terms" name="signup-terms">
                                          <span class="css-control-indicator"></span>
                                          I agree to Terms &amp; Conditions
                                      </label>
                                  </div>
                              </div>
                              <div class="form-group row gutters-tiny">
                                  <div class="col-12 mb-10">
                                      <button type="button" (click)="Register()" class="btn btn-block btn-hero btn-noborder btn-rounded btn-alt-success">
                                          <i class="si si-user-follow mr-10"></i> Sign Up
                                      </button>
                                  </div>

                              </div>
                          </form>
                      </div>
                  </div>
                  <!-- END Sign Up Form -->
                  </div>


              </div>
          </div>
          <!-- END Page Content -->
      </main>
      <!-- END Main Container -->
  </div>
  <!-- END Page Container -->



